import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { SocketActions } from '@store/socketSaga'
import { select } from 'redux-saga/effects'

import { socket } from '../socket'

export function* emit({
  payload: { eventName, readonlyProjectId, payload: action },
}: ReturnType<typeof SocketActions.emit>) {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (!projectId) {
    return
  }

  if (!socket.connected) {
    // biome-ignore lint/suspicious/noConsole: intentional
    console.warn('Socket not connected')
    return
  }

  const id = readonlyProjectId || projectId

  socket.emit(eventName, id, action)
}
